interface QuillEditor {
    quill: {
      history: {
        undo: () => void;
        redo: () => void;
      };
    };
  }
  function undoChange(this: QuillEditor) { this.quill.history.undo()}
  function redoChange(this: QuillEditor) {this.quill.history.redo()}
  
  // Modules object for setting up the Quill editor
  export const modules = {
    toolbar: {
      container: "#toolbar",
      handlers: {
        undo: undoChange,
        redo: redoChange
      }
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true
    }
  };
  
  // Formats objects for setting up the Quill editor
  export const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "align",
    "strike",
    "script",
    "blockquote",
    "background",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "code-block"
  ];
  
  // Quill Toolbar component
  export const QuillToolbar = () => (
    <div id="toolbar">
      <span className="ql-formats">
        <select className="ql-header" defaultValue="3">
          <option value="1">Heading</option>
          <option value="2">Subheading</option>
          <option value="3">Normal</option>
        </select>
      </span>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
      </span>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
      </span>
    </div>
  );